// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'os-apple';

export const Component = () => (
  <path
    fill='currentColor'
    d='M15.884 12.685c-.31.897-.69 1.724-1.207 2.483-.862 1.276-1.724 1.931-2.552 1.931-.31 0-.793-.103-1.379-.344-.552-.207-1.034-.31-1.483-.31a3.02 3.02 0 0 0-1.379.344c-.552.207-1 .31-1.31.31-1.034 0-2.035-.862-2.966-2.551-.965-1.69-1.448-3.31-1.448-4.931 0-1.483.38-2.69 1.104-3.69.724-.93 1.655-1.413 2.793-1.413.448 0 1.034.104 1.758.276.69.207 1.138.31 1.345.31.31 0 .793-.103 1.414-.345.759-.241 1.345-.344 1.724-.344.759 0 1.448.207 2.069.655.379.275.724.62 1.034 1-.482.38-.862.759-1.103 1.138-.449.586-.656 1.276-.656 2.034 0 .794.242 1.552.69 2.207.448.655.965 1.069 1.552 1.242zM12.16 1.03v.104c0 .448-.104.897-.276 1.345-.241.517-.517.965-.897 1.345-.31.31-.69.552-1.068.724-.31.103-.656.138-1.035.172.035-1 .276-1.828.759-2.552.483-.69 1.31-1.172 2.483-1.448v.103l.034.104v.103z'
  />
);

export const viewBox = '0 0 18 18';
